import moment from 'moment'

export function getDateFromString(value: string): Date | null {
  if (value) {
    const date = moment(value).toDate()
    return date
  }

  return null
}

export function getStringFromDate(value: Date): string | null {
  if (value) {
    const dateString = moment(value).format('YYYY-MM-DDTHH:mm:ss')
    return dateString
  }

  return null
}

export const isWeekend = (date: moment.Moment): boolean => {
  const day = date.day()
  return day === 0 || day === 6
}

export const areDatesEqual = (leftDate: Date, rightDate: Date): boolean => {
  return moment(leftDate).startOf('day').isSame(moment(rightDate).startOf('day'))
}

export const isLimitDateReached = (limitDate?: string | null): boolean => {
  if (!limitDate) {
    return false
  }

  const today = moment().startOf('day')
  const limit = moment(limitDate).startOf('day')

  return today.isSameOrAfter(limit)
}

export const isLimitDateSoon = (limitDate?: string | null, daysBeforeWarning: number = 3): boolean => {
  if (!limitDate) {
    return false
  }

  const today = moment().startOf('day')
  const limit = moment(limitDate).startOf('day')
  const warningDate = limit.clone().subtract(daysBeforeWarning, 'days')

  return today.isSameOrAfter(warningDate) && today.isBefore(limit)
}
